import colums from "@/colums/colums"
export default{
  getAwardCate(state){
    let cate = state.awardCate
    cate.map(t=>{
      if(t.name=='节目'){
        t.list = colums.jmkcate
      }
      if(t.name =='展品'){
        t.list = colums.exhibitCate
      }
      if(t.name =='文学'){
        t.list = colums.literatureCate
      }
    })
    return cate
  }
}